module.exports = __webpack_public_path__ + "img/1.6b27a6d2.png";